import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';

import { IconDirective } from '../icon/icon.directive';

@Component({
  standalone: true,
  selector: 'shared-sidebar-placeholder',
  templateUrl: './sidebar-placeholder.component.html',
  styleUrls: ['./sidebar-placeholder.component.scss'],
  imports: [TranslocoModule, MatIconModule, IconDirective],
})
export class SidebarPlaceholderComponent {}
